import { useState, useEffect, useCallback } from "react";
import { useGetProductsQuery } from "../redux/api";

export const useLoadProducts = () => {
    const [shouldFetch, setShouldFetch] = useState(false);
    const { data, isLoading, isError, refetch } = useGetProductsQuery(
        {  },
        { skip: !shouldFetch, refetchOnMountOrArgChange: true }
    );

    useEffect(() => {
        if (shouldFetch) {
            refetch();
        }
    }, [shouldFetch, refetch]);

    useEffect(() => {
        if (!isLoading && data && !isError) {
            setShouldFetch(false);
        } else if (!isLoading && isError) {
            setShouldFetch(false);
        }
    }, [data, isError, isLoading]);

    const loadProducts = useCallback(() => {
        setShouldFetch(true);
    }, []);

    return { loadProducts, isLoading, data, isError };
};